import { createTheme } from '@mui/material/styles';

const nbxTheme = createTheme({
  palette: {
    primary: {
      main: '#46AA71',
      light: '#40875e',
      dark: '#40875e',
      contrastText: '#FFFFFF',
    },
    gray: {
      main: '#64748B',
      light: '#64748B',
      dark: '#64748B',
      contrastText: '#64748B',
    }
  },
  components: {
   
  },
});

export default nbxTheme;
